module.exports = __webpack_public_path__ + "static/media/plx-bg.7bfa1381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plx-bg.png
// module id = 681
// module chunks = 0